import React, { useEffect, useState } from "react";
import { Search, Clock, X, Info } from "lucide-react";
import { api } from "../lib/api";

const idr = (n) => `Rp. ${(Number(n) || 0).toLocaleString("id-ID")}`;
const fmt = (iso) => { if (!iso) return "-"; try { return new Date(iso).toLocaleString("en-US", { month: "short", day: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return iso; } };

export default function PublicKeepCheck() {
  const [meta, setMeta] = useState({ app_name: "Ventedaily" });
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [keep, setKeep] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => { api.get("/public/meta").then((r) => setMeta(r.data)).catch(() => {}); }, []);

  const search = async () => {
    if (!q.trim()) return setErr("Masukkan Keep ID atau Order ID");
    setLoading(true); setErr("");
    try {
      const r = await api.get("/public/keep", { params: { q: q.trim() } });
      setKeep(r.data); setShow(true);
    } catch (e) { setKeep(null); setShow(false); setErr(e.response?.data?.detail || "Keep aktif tidak ditemukan"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#eef1f6] flex flex-col items-center pt-24 px-4" data-testid="public-keepcheck-page">
      <div className="bg-white rounded-2xl shadow-sm border border-[#e7eaf2] w-full max-w-md p-7">
        <h1 className="text-2xl font-heading font-bold text-[#2f3446] text-center">Check Active Keep Status</h1>
        <p className="text-sm text-slate-500 text-center mt-1">Masukkan Keep ID atau Order ID untuk cek status</p>
        {keep && (
          <div className="mt-3 flex items-center justify-center gap-1.5 text-sm text-indigo-500"><Clock className="w-4 h-4" /> Aktif s/d: {fmt(keep.end_keep)}</div>
        )}
        <div className="relative mt-5">
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()} data-testid="keepcheck-input"
            placeholder="mis. A42848 atau PO-30-01" autoFocus
            className="w-full pl-4 pr-10 py-3 rounded-lg border border-indigo-300 bg-white text-[#2f3446] outline-none focus:ring-2 focus:ring-indigo-200" />
          <Search className="w-4 h-4 absolute right-3.5 top-3.5 text-slate-400" />
        </div>
        <button onClick={search} disabled={loading} data-testid="keepcheck-search-btn"
          className="w-full mt-3 py-3 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60">
          <Search className="w-4 h-4" /> {loading ? "Mencari…" : "Search"}
        </button>
        {err && <div className="mt-3 text-center text-sm text-rose-500" data-testid="keepcheck-error">{err}</div>}
        <div className="mt-4 text-center text-xs text-slate-400 space-y-0.5">
          <div className="flex items-center justify-center gap-1"><Info className="w-3.5 h-3.5" /> Hanya keep berstatus aktif yang ditampilkan.</div>
          <div>Anda bisa mencari dengan Keep ID atau Order ID Marketplace.</div>
        </div>
      </div>

      {show && keep && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={() => setShow(false)} data-testid="keepcheck-detail">
          <div className="bg-white rounded-xl shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
              <h2 className="text-lg font-semibold text-[#2f3446]">Keep Details</h2>
              <button onClick={() => setShow(false)} data-testid="keepcheck-close" className="text-slate-400 hover:text-slate-700"><X className="w-5 h-5" /></button>
            </div>
            <div className="p-6 space-y-5">
              <div className="border border-slate-200 rounded-xl p-4 grid grid-cols-2 md:grid-cols-6 gap-4 text-sm">
                <div><div className="text-slate-400 text-xs">No Keep:</div><div className="font-semibold text-[#2f3446]">{keep.number}</div></div>
                <div><div className="text-slate-400 text-xs">Type:</div><div className="font-semibold text-[#2f3446]">{keep.type}</div></div>
                <div><div className="text-slate-400 text-xs">Customer Name:</div><div className="font-semibold text-[#2f3446]">{keep.customer_name || "-"}</div></div>
                <div><div className="text-slate-400 text-xs">End Keep:</div><div className="font-semibold text-[#2f3446]">{fmt(keep.end_keep)}</div></div>
                <div><div className="text-slate-400 text-xs">Marketplace:</div><div className="font-semibold text-[#2f3446]">{keep.marketplace || "-"}</div></div>
                <div><div className="text-slate-400 text-xs">Order ID Marketplace:</div><div className="font-semibold text-[#2f3446]">{keep.order_id || "-"}</div></div>
              </div>
              <div className="border border-slate-200 rounded-xl p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-[#2f3446]">Product Details</h3>
                  <span className="text-xs px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-600 font-medium">Total Items: {keep.total_items}</span>
                </div>
                <table className="w-full text-sm">
                  <thead><tr className="text-left text-slate-400 border-b border-slate-100"><th className="py-2 px-2 w-12">No</th><th className="py-2 px-2">Name</th><th className="py-2 px-2">Color</th><th className="py-2 px-2">Size</th><th className="py-2 px-2">Price</th><th className="py-2 px-2 text-center">Qty</th><th className="py-2 px-2 text-right">Total Price</th></tr></thead>
                  <tbody>
                    {keep.items.map((it, i) => (
                      <tr key={i} className="border-b border-slate-50" data-testid={`keepcheck-item-${i}`}>
                        <td className="py-2 px-2">{i + 1}</td>
                        <td className="py-2 px-2 text-[#2f3446]">{it.product_name}</td>
                        <td className="py-2 px-2 text-slate-600">{it.color || "-"}</td>
                        <td className="py-2 px-2 text-slate-600">{it.size || "-"}</td>
                        <td className="py-2 px-2 text-slate-600">{idr(it.price)}</td>
                        <td className="py-2 px-2 text-center text-slate-600">{it.qty}</td>
                        <td className="py-2 px-2 text-right font-semibold text-[#2f3446]">{idr(it.total)}</td>
                      </tr>
                    ))}
                    <tr className="bg-slate-50">
                      <td colSpan={5} className="py-2 px-2 text-right text-slate-500 font-medium">Total:</td>
                      <td className="py-2 px-2 text-center font-semibold">{keep.total_items}</td>
                      <td className="py-2 px-2 text-right font-bold text-emerald-600">{idr(keep.total)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="px-6 py-4 border-t border-slate-100 flex justify-end">
              <button onClick={() => setShow(false)} className="px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-600 text-sm" data-testid="keepcheck-cancel">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
